import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useHistoryStack } from './useHistoryStack';

const MAX_LENGTH = 10;

export const useHistoryTracker = () => {
  const setHistoryStack = useHistoryStack()[1];
  const location = useLocation();

  useEffect(() => {
    setHistoryStack(prevStack => {
      prevStack.push(location);

      if (prevStack.length > MAX_LENGTH) {
        prevStack.shift(); // Remove the oldest entry to keep the stack length manageable
      }

      return prevStack;
    });
  }, [location, setHistoryStack]);
};
